import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { App, Plugin } from "vue";

export const VeeValidatePlugin: Plugin = {
  install(app: App) {
    app.component("ValidationProvider", ValidationProvider);
    app.component("ValidationObserver", ValidationObserver);

    Object.keys(rules).forEach((rule) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      extend(rule, rules[rule]);
    });

    extend("rangePropertyValue", {
      validate(propertyValue) {
        if (propertyValue >= 150000000 && propertyValue <= 450000000) {
          return true;
        }
        return false;
      },
      message: () => {
        return "Debes ingresar un valor entre 150.000.000 y 450.000.000";
      },
    });

    extend("rangePercentageInitialFee", {
      validate(percentageInitialFee) {
        if (percentageInitialFee >= 15 && percentageInitialFee <= 50) {
          return true;
        }
        return false;
      },
      message: () => {
        return "Debes ingresar un valor entre 15% y 50%";
      },
    });

    extend("rangeCreditTerm", {
      validate(creditTerm) {
        if (creditTerm >= 12 && creditTerm <= 60) {
          return true;
        }
        return false;
      },
      message: () => {
        return "Debes ingresar un tiempo entre 12 y 60 meses";
      },
    });
  },
};
